import { useState } from "react";
import { Button, Card, Col, Row } from "react-bootstrap";
import HyperledgerBesu from "../../assets/images/hyperledger-besu.svg"
import Binance from "../../assets/images/binance.svg"
import Algorand from "../../assets/images/algorand.svg"
import GoogleCloud from "../../assets/images/google-cloud.svg"
import AmazonWebServicesBlack from "../../assets/images/amazon-web-services-black.svg"
import FlagOfBelgium from "../../assets/images/flag-of-belgium.svg"
import { AlgorandLaunchpad } from "../Algorand/Launchpad"
import { AlgorandBond } from "../Algorand/Bond"
import { BinanceLaunchpad } from "../Binance/Launchpad"
import { BinanceBond } from "../Binance/Bond"
import Iframe from 'react-iframe'

var createGuest = require("cross-domain-storage/guest");
var createHost = require("cross-domain-storage/host");
var storageHost = createHost([
  {
    origin: "https://sigma-ui-self.vercel.app/",
    allowedMethods: ["get", "set", "remove"],
  },
  {
    origin: "https://sandboxv1.elementfi.io/",
    allowedMethods: ["get"],
  },
]);

const SmartContracts = () => {
    const [modal, setModal] = useState(false);
    const [stepFirst, setStepFirst] = useState(true);
    const [stepSecDisabled, setStepSecDisabled] = useState(true);
    const [step, setStep] = useState(1);
    const [stepInner, setStepInner] = useState(0);
    const [stepInner1, setStepInner1] = useState(0);
    const [stepInner2, setStepInner2] = useState(0);
    const [stepInner3, setStepInner3] = useState(0);
    // const [inputNumber, setInputNumber] = useState('');

    const handleModal = () => {
        setModal(!modal);
        setStep(1);
    }

    const chosenContract = async (opt) =>
    {
        if(opt === "Launchpad" && localStorage.getItem("network") === "Algorand")
        {
            localStorage.setItem("contract", "AlgorandLaunchpad")
        }
        else if(opt === "Bond" && localStorage.getItem("network") === "Algorand")
        {
            localStorage.setItem("contract", "AlgorandBond")
        }
        else if(opt === "Launchpad" && localStorage.getItem("network") === "Binance")
        {
            localStorage.setItem("contract", "BinanceLaunchpad")
        }
        else if(opt === "Bond" && localStorage.getItem("network") === "Binance")
        {
            localStorage.setItem("contract", "BinanceBond")
        }
        else if(opt === "Launchpad" && localStorage.getItem("network") === "Sidechain")
        {
            localStorage.setItem("contract", "SidechainLaunchpad")
        }
        else if(opt === "Launchpad" && localStorage.getItem("network") === "Sidechain")
        {
            localStorage.setItem("contract", "SidechainBond")
        }
    }

    const deployContract = async () =>
    {
        if(localStorage.getItem("contract") === "AlgorandLaunchpad")
        {
                await AlgorandLaunchpad();
        }
        else if(localStorage.getItem("contract") === "AlgorandBond")
        {
                await AlgorandBond();
        }
        else if(localStorage.getItem("contract") === "BinanceLaunchpad")
        {
                await BinanceLaunchpad();
        }
        else if(localStorage.getItem("contract") === "BinanceBond")
        {
                await BinanceBond();
        }
        else if(localStorage.getItem("contract") === "SidechainLaunchpad")
        {
                // await SidechainLaunchpad();
        }
        else if(localStorage.getItem("contract") === "SidechainBond")
        {
                // await SidechainBond();
        }
    }

    const networkSelectAlgorand = async() =>
    {
        setStepFirst(false);
        localStorage.setItem("network", "Algorand");
    }

    const networkSelectBinance = async() =>
    {
        setStepFirst(false);
        localStorage.setItem("network", "Binance");
    }

    const networkSelectSidechain = async() =>
    {
        setStepFirst(false);
        localStorage.setItem("network", "Sidechain");
    }

    return ( 
        <>
            <Card className="card-dark mb-3">
                <Card.Body className="p-4">
                    <Row className="align-items-center">
                        <Col sm={8} className="mb-sm-0 mb-3">
                            <h4>Smart contracts</h4>
                            <p>Use smart contract sets to add business logic to your application. IDE and configurable templates included.</p>
                        </Col>
                        <Col sm={4} className="text-center text-sm-end">
                        {localStorage.getItem('Login') === true || localStorage.getItem('Login') || localStorage.getItem('Login') ==="true" ?(<>
                            <Button onClick={handleModal}>Configure</Button>
                           
                        </>):(<>
                        
                            <Button  disabled onClick={handleModal}>Configure</Button>
                        </>)}
                        </Col>
                    </Row>
                </Card.Body>
            </Card>

            <div className={`modal-outer ${modal ? 'active' : ''}`}>
                <div class="modal-overlay"></div>
                <div className="modal_content">
                    <button className="btn_close" onClick={handleModal}>
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" aria-hidden="true"><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"></path></svg>
                    </button>

                    {step === 1 && (
                        <div className="modal-section">
                            <div className="mb-5">
                                <h3 className="mb-4">Select a blockchain network for your smart contract set</h3>

                                <h5>Select your network preference</h5>
                                <p>You can choose the blockhain network which your smart contracts will run on. <a href="/">Learn more</a></p>
                            </div>
                            <Row>
                                <Col md={4} className="mb-4">
                                    <h6 className="mb-3">Private network</h6>

                                    <Row>
                                        <Col md={12} sm={6} className="mb-3">
                                            <label className="label-card">
                                                <input type="radio" hidden name="network-preference" onChange={() => networkSelectSidechain()} />
                                                <span className="d-flex justify-content-center align-items-center">
                                                    <span className="me-2"><img src={Binance} alt="Sidechain" /></span>
                                                    <span className="label-card-name">BSC sidechain</span>
                                                </span>
                                            </label>
                                        </Col>
                                        {/* <Col md={12} sm={6} className="mb-3">
                                            <label className="label-card">
                                                <input type="radio" hidden name="network-preference" onChange={() => setStepFirst(false)} />
                                                <span className="d-flex justify-content-center align-items-center">
                                                    <span className="me-2"><img src={HyperledgerBesu} alt="HyperledgerBesu" /></span>
                                                    <span className="label-card-name">Hyperledger Besu</span>
                                                </span>
                                            </label>
                                        </Col>
                                        <Col md={12} sm={6} className="mb-3">
                                            <label className="label-card">
                                                <input type="radio" hidden name="network-preference" onChange={() => setStepFirst(false)} />
                                                <span className="d-flex justify-content-center align-items-center">
                                                    <span className="me-2"><img src={HyperledgerBesu} alt="HyperledgerBesu" /></span>
                                                    <span className="label-card-name">Hyperledger Besu</span>
                                                </span>
                                            </label>
                                        </Col> */}
                                    </Row>
                                </Col>
                                {/* <Col md={4} className="mb-4">
                                    <h6 className="mb-3">Public network - Mainnet</h6>

                                    <Row>
                                        <Col md={12} sm={6} className="mb-3">
                                            <label className="label-card">
                                                <input type="radio" hidden name="network-preference" onChange={() => setStepFirst(false)} />
                                                <span className="d-flex justify-content-center align-items-center">
                                                    <span className="me-2"><img src={HyperledgerBesu} alt="HyperledgerBesu" /></span>
                                                    <span className="label-card-name">Hyperledger Besu</span>
                                                </span>
                                            </label>
                                        </Col>
                                        <Col md={12} sm={6} className="mb-3">
                                            <label className="label-card">
                                                <input type="radio" hidden name="network-preference" onChange={() => setStepFirst(false)} />
                                                <span className="d-flex justify-content-center align-items-center">
                                                    <span className="me-2"><img src={Binance} alt="Binance" /></span>
                                                    <span className="label-card-name">Binance Smart Chain</span>
                                                </span>
                                            </label>
                                        </Col>
                                        <Col md={12} sm={6} className="mb-3">
                                            <label className="label-card">
                                                <input type="radio" hidden name="network-preference" onChange={() => setStepFirst(false)} />
                                                <span className="d-flex justify-content-center align-items-center">
                                                    <span className="me-2"><img src={Binance} alt="Binance" /></span>
                                                    <span className="label-card-name">Binance Smart Chain</span>
                                                </span>
                                            </label>
                                        </Col>
                                    </Row>
                                </Col> */}
                                <Col md={4} className="mb-4">
                                    <h6 className="mb-3">Public network - Testnet</h6>

                                    <Row>
                                        <Col md={12} sm={6} className="mb-3">
                                            <label className="label-card">
                                                <input type="radio" hidden name="network-preference" onChange={() => networkSelectBinance()} />
                                                <span className="d-flex justify-content-center align-items-center">
                                                    <span className="me-2"><img src={Binance} alt="Binance" /></span>
                                                    <span className="label-card-name">BSC Testnet</span>
                                                </span>
                                            </label>
                                        </Col>
                                        <Col md={12} sm={6} className="mb-3">
                                            <label className="label-card">
                                                <input type="radio" hidden name="network-preference" onChange={() => networkSelectAlgorand()} />
                                                <span className="d-flex justify-content-center align-items-center">
                                                    <span className="me-2"><img src={Algorand} alt="Algorand" /></span>
                                                    <span className="label-card-name">Algorand</span>
                                                </span>
                                            </label>
                                        </Col>
                                        {/* <Col md={12} sm={6} className="mb-3">
                                            <label className="label-card">
                                                <input type="radio" hidden name="network-preference" onChange={() => setStepFirst(false)} />
                                                <span className="d-flex justify-content-center align-items-center">
                                                    <span className="me-2"><img src={HyperledgerBesu} alt="HyperledgerBesu" /></span>
                                                    <span className="label-card-name">Hyperledger Besu</span>
                                                </span>
                                            </label>
                                        </Col> */}
                                    </Row>
                                </Col>
                            </Row>

                            <div className="d-flex align-items-center justify-content-end">
                                <Button onClick={handleModal} variant="outline-primary me-3">Close</Button>
                                <Button onClick={() => setStep(2)} disabled={stepFirst}>Confirm</Button>
                            </div>
                        </div>
                    )}
                    {/* step 1 */}

                    {step === 2 && (
                        <div className="modal-section">
                            <h3 className="mb-4">Add a smart contract set for Ethereum</h3>
                            <div className="mb-5">
                                <div className="mb-4">
                                    {/* <h5>Step 1/2 - Choose template</h5> */}
                                    <h5>Choose template</h5>
                                    <p>Every instance of the Integrated Development Environment (IDE) contains a set of pre-built smart contract templates. These templates are easily customizable to match your specific use case. The IDE for Ethereum uses Solidity as a programming language.</p>
                                </div>
                                <div className="mb-1">
                                    <Row>
                                    <Iframe url="https://sandboxv1.elementfi.io//"
                                    width="680px"
                                    height="560px"
                                    display="block"
                                    position="relative"/>
                                        {/* <Col md={3} xs={6} className="mb-3">
                                            <label className="label-card">
                                                <input type="radio" hidden name="choose-template" onChange={() => chosenContract("Launchpad")} />
                                                <span className="d-flex justify-content-center align-items-center">
                                                    <span className="label-card-name">Launchpad</span>
                                                </span>
                                            </label>
                                        </Col>
                                        <Col md={3} xs={6} className="mb-3">
                                            <label className="label-card">
                                                <input type="radio" hidden name="choose-template" onChange={() => chosenContract("Bond")} />
                                                <span className="d-flex justify-content-center align-items-center">
                                                    <span className="label-card-name">Bond</span>
                                                </span>
                                            </label> */}
                                            {/* <a href="/">Learn more</a> */}
                                        {/* </Col> */}
                                        {/* <Col md={3} xs={6} className="mb-3">
                                            <label className="label-card">
                                                <input type="radio" hidden name="choose-template" onChange={() => setStepInner(1)} />
                                                <span className="d-flex justify-content-center align-items-center">
                                                    <span className="label-card-name">ERC-20 Token</span>
                                                </span>
                                            </label>
                                            <a href="/">Learn more</a>
                                        </Col>
                                        <Col md={3} xs={6} className="mb-3">
                                            <label className="label-card">
                                                <input type="radio" hidden name="choose-template" onChange={() => setStepInner(1)} />
                                                <span className="d-flex justify-content-center align-items-center">
                                                    <span className="label-card-name">ERC-20 Token Crowd Sale</span>
                                                </span>
                                            </label>
                                            <a href="/">Learn more</a>
                                        </Col>
                                        <Col md={3} xs={6} className="mb-3">
                                            <label className="label-card">
                                                <input type="radio" hidden name="choose-template" onChange={() => setStepInner(1)} />
                                                <span className="d-flex justify-content-center align-items-center">
                                                    <span className="label-card-name">ERC-20 Token Meta Tx</span>
                                                </span>
                                            </label>
                                            <a href="/">Learn more</a>
                                        </Col>
                                        <Col md={3} xs={6} className="mb-3">
                                            <label className="label-card">
                                                <input type="radio" hidden name="choose-template" onChange={() => setStepInner(1)} />
                                                <span className="d-flex justify-content-center align-items-center">
                                                    <span className="label-card-name">ERC-721 Token</span>
                                                </span>
                                            </label>
                                            <a href="/">Learn more</a>
                                        </Col>
                                        <Col md={3} xs={6} className="mb-3">
                                            <label className="label-card">
                                                <input type="radio" hidden name="choose-template" onChange={() => setStepInner(1)} />
                                                <span className="d-flex justify-content-center align-items-center">
                                                    <span className="label-card-name">ERC-721a Token</span>
                                                </span>
                                            </label>
                                            <a href="/">Learn more</a>
                                        </Col>
                                        <Col md={3} xs={6} className="mb-3">
                                            <label className="label-card">
                                                <input type="radio" hidden name="choose-template" onChange={() => setStepInner(1)} />
                                                <span className="d-flex justify-content-center align-items-center">
                                                    <span className="label-card-name">Miscellaneous</span>
                                                </span>
                                            </label>
                                            <a href="/">Learn more</a>
                                        </Col> */}
                                    </Row>
                                </div>
                                {/* <div className="d-flex flex-wrap align-items-center justify-content-between">
                                {!stepSecDisabled && <h5 className="my-2">Cost: € 1.55/h (€ 1116.0/mo)</h5>}
                                <div className="d-flex ms-auto align-items-center justify-content-end">
                                    <Button onClick={handleModal} variant="outline-primary me-3">Close</Button>
                                    <Button onClick={() => deployContract()}>Confirm</Button>
                                </div>
                            </div> */}
                            </div>  

                            {/* {stepInner === 0 && (
                                <>
                                    <h5 className="mb-3" style={{opacity: .5}}>Step 2/2 - Choose a deployment plan</h5>
                                    <div className="d-flex flex-wrap align-items-center justify-content-between">
                                        {!stepSecDisabled && <h5 className="my-2">Cost: € 1.55/h (€ 1116.0/mo)</h5>}
                                        <div className="d-flex ms-auto align-items-center justify-content-end">
                                            <Button onClick={handleModal} variant="outline-primary me-3">Close</Button>
                                            <Button disabled={stepSecDisabled}>Configure else</Button>
                                        </div>
                                    </div>
                                </>
                            )} */}
                        </div>
                    )}
                    {/* step 2 */}
                    
                    {/* {stepInner === 1 && (
                        <div className="modal-section">
                            <div className="mb-5">
                                <div className="mb-4">
                                    <h5>Step 2/2 - Choose a deployment plan</h5>
                                    <p>Choose the type of infrastructure, cloud provider and region, and the level of resources available to your smart contract set. <a href="/">Learn more</a></p>
                                </div>
                                <div className="mb-1">
                                    <h6 className="mb-3">Type</h6>
                                    <Row>
                                        <Col md={3} xs={6} className="mb-4">
                                            <label className="label-card">
                                                <input type="radio" hidden name="type" onChange={() => setStepInner1(1)} />
                                                <span className="d-flex justify-content-center align-items-center">
                                                    <span className="label-card-name">Shared</span>
                                                </span>
                                            </label>
                                        </Col>
                                        <Col md={3} xs={6} className="mb-4">
                                            <label className="label-card">
                                                <input type="radio" hidden name="type" onChange={() => setStepInner1(1)} />
                                                <span className="d-flex justify-content-center align-items-center">
                                                    <span className="label-card-name">Dedicated</span>
                                                </span>
                                            </label>
                                        </Col>
                                        <Col md={3} xs={6} className="mb-4">
                                            <a className="label-card" href="mailto:example@gmail.com">
                                                <span className="d-flex justify-content-center align-items-center">
                                                    <span className="label-card-name">On Premise <span>contact us</span></span>
                                                </span>
                                            </a>
                                        </Col>
                                        <Col md={3} xs={6} className="mb-4">
                                            <a className="label-card" href="mailto:example@gmail.com">
                                                <span className="d-flex justify-content-center align-items-center">
                                                    <span className="label-card-name">Bring your own cloud <span>contact us</span></span>
                                                </span>
                                            </a>
                                        </Col>
                                    </Row>
                                </div>

                                {stepInner1 === 1 && (
                                    <div className="mb-1">
                                        <h6 className="mb-3">Cloud provider</h6>
                                        <Row>
                                            <Col md={4} sm={6} className="mb-4">
                                                <label className="label-card">
                                                    <input type="radio" hidden name="cloud-provider" onChange={() => setStepInner2(1)} />
                                                    <span className="d-flex justify-content-center align-items-center">
                                                        <span className="me-2"><img src={GoogleCloud} alt="GoogleCloud" /></span>
                                                        <span className="label-card-name">Google Cloud</span>
                                                    </span>
                                                </label>
                                            </Col>
                                            <Col md={4} sm={6} className="mb-4">
                                                <label className="label-card">
                                                    <input type="radio" hidden name="cloud-provider" onChange={() => setStepInner2(1)} />
                                                    <span className="d-flex justify-content-center align-items-center">
                                                        <span className="me-2"><img src={AmazonWebServicesBlack} alt="AmazonWebServicesBlack" /></span>
                                                        <span className="label-card-name">AWS</span>
                                                    </span>
                                                </label>
                                            </Col>
                                            <Col md={4} sm={6} className="mb-4">
                                                <a className="label-card" href="mailto:example@gmail.com">
                                                    <span className="d-flex justify-content-center align-items-center">
                                                        <span className="label-card-name"><div className="d-flex justify-content-center align-items-center"><span className="me-2"><img src={AmazonWebServicesBlack} alt="AmazonWebServicesBlack" /></span> AWS</div> <span>contact us</span></span>
                                                    </span>
                                                </a>
                                            </Col>
                                        </Row>
                                    </div>
                                )}

                                {stepInner2 === 1 && (
                                    <div className="mb-1">
                                        <h6 className="mb-3">Region</h6>
                                        <Row>
                                            <Col md={3} sm={6} className="mb-4">
                                                <label className="label-card">
                                                    <input type="radio" hidden name="region" onChange={() => setStepInner3(1)} />
                                                    <span className="d-flex justify-content-center align-items-center">
                                                        <span className="me-2"><img src={FlagOfBelgium} alt="FlagOfBelgium" /></span>
                                                        <span className="label-card-name">Brussels</span>
                                                    </span>
                                                </label>
                                            </Col>
                                            <Col md={3} sm={6} className="mb-4">
                                                <label className="label-card">
                                                    <input type="radio" hidden name="region" onChange={() => setStepInner3(1)} />
                                                    <span className="d-flex justify-content-center align-items-center">
                                                        <span className="me-2"><img src={FlagOfBelgium} alt="FlagOfBelgium" /></span>
                                                        <span className="label-card-name">Singapore</span>
                                                    </span>
                                                </label>
                                            </Col>
                                            <Col md={3} sm={6} className="mb-4">
                                                <label className="label-card">
                                                    <input type="radio" hidden name="region" onChange={() => setStepInner3(1)} />
                                                    <span className="d-flex justify-content-center align-items-center">
                                                        <span className="me-2"><img src={FlagOfBelgium} alt="FlagOfBelgium" /></span>
                                                        <span className="label-card-name">Mumbai</span>
                                                    </span>
                                                </label>
                                            </Col>
                                            <Col md={3} sm={6} className="mb-4">
                                                <a className="label-card" href="mailto:example@gmail.com">
                                                    <span className="d-flex justify-content-center align-items-center">
                                                        <span className="label-card-name"><div className="d-flex justify-content-center align-items-center"><span className="me-2"><img src={FlagOfBelgium} alt="FlagOfBelgium" /></span> Oregon</div> <span>contact us</span></span>
                                                    </span>
                                                </a>
                                            </Col>
                                        </Row>
                                    </div>
                                )}

                                {stepInner3 === 1 && (
                                    <div className="mb-1">
                                        <h6 className="mb-3">Resource pack</h6>
                                        <Row>
                                            <Col md={4} sm={6} className="mb-4">
                                                <label className="label-card">
                                                    <input type="radio" hidden name="resource-pack" onChange={() => setStepSecDisabled(false)} />
                                                    <span className="d-flex text-center flex-column">
                                                        <p className="mb-0">
                                                            <strong className="d-block">Small</strong>
                                                            <span class="font-normal">€ 0.14/h (€ 101/mo)<br />excl. VAT</span>
                                                        </p>
                                                        <hr />
                                                        <p className="mb-0">
                                                            <span>0.25 GB Memory</span><br /><span>0.25 vCPU</span><br /><span>10 req/s</span>
                                                        </p>
                                                    </span>
                                                </label>
                                            </Col>
                                            <Col md={4} sm={6} className="mb-4">
                                                <label className="label-card">
                                                    <input type="radio" hidden name="resource-pack" onChange={() => setStepSecDisabled(false)} />
                                                    <span className="d-flex text-center flex-column">
                                                        <p className="mb-0">
                                                            <strong className="d-block">Medium</strong>
                                                            <span class="font-normal">€ 0.14/h (€ 101/mo)<br />excl. VAT</span>
                                                        </p>
                                                        <hr />
                                                        <p className="mb-0">
                                                            <span>0.25 GB Memory</span><br /><span>0.25 vCPU</span><br /><span>10 req/s</span>
                                                        </p>
                                                    </span>
                                                </label>
                                            </Col>
                                            <Col md={4} sm={6} className="mb-4">
                                                <label className="label-card">
                                                    <input type="radio" hidden name="resource-pack" onChange={() => setStepSecDisabled(false)} />
                                                    <span className="d-flex text-center flex-column">
                                                        <p className="mb-0">
                                                            <strong className="d-block">Large</strong>
                                                            <span class="font-normal">€ 0.14/h (€ 101/mo)<br />excl. VAT</span>
                                                        </p>
                                                        <hr />
                                                        <p className="mb-0">
                                                            <span>0.25 GB Memory</span><br /><span>0.25 vCPU</span><br /><span>10 req/s</span>
                                                        </p>
                                                    </span>
                                                </label>
                                            </Col>
                                        </Row>
                                    </div>
                                )}
                            </div>  

                            <div className="d-flex flex-wrap align-items-center justify-content-between">
                                {!stepSecDisabled && <h5 className="my-2">Cost: € 1.55/h (€ 1116.0/mo)</h5>}
                                <div className="d-flex ms-auto align-items-center justify-content-end">
                                    <Button onClick={handleModal} variant="outline-primary me-3">Close</Button>
                                    <Button disabled={stepSecDisabled}>Configure else</Button>
                                </div>
                            </div>
                        </div>
                    )} */}
                    {/* step 3 */}

                </div>
            </div>
        </>
     );
}
 
export default SmartContracts;